import { PresentationAct } from "onearm";
import gsap from "gsap";

export class FreeSpinRetriggerAct extends PresentationAct {
    constructor({ result, hud }) {
        super({ skipStep: true });
        this.hud = hud;
        this.result = result;
    }

    action() {
        const tl = this.timeline;

        const popup = this.hud.layout.findAll("AddFreeSpinsPopup");

        this.hud.layout.forAll("AddFreeSpinsPopup.fsValue", (value) => {
            value.text = `+${this.result.award.number}`;
        });

        this.hud.layout.forAll("AddFreeSpinsPopup", (obj) => {
            // obj.pivot.set(obj.width / 2, obj.height / 2);
            // obj.position.set(obj.x + obj.width / 2, obj.y + obj.height / 2);
        });

        tl.set(popup, { visible: true, alpha: 0 });
        tl.add([
            gsap.to(popup, { alpha: 1, duration: 0.5 }),
            // gsap.to(popup, { pixi: {scaleX: 1.25, scaleY: 1.25 }, duration: 0.5 }),
        ]);

        tl.add([
            gsap.to(popup, { alpha: 0, duration: 0.5 }),
            // gsap.to(popup, { pixi: {scaleX: 1.5, scaleY: 1.5 }, duration: 0.5 }),
        ], "+=0.5");

        tl.add("skip");

        return tl;
    }

    skip() {
        this.timeline.seek("skip");
    }
}
